import { render, staticRenderFns } from "./PortletUnfixedVulnerabilities.vue?vue&type=template&id=17338c9a"
import script from "./PortletUnfixedVulnerabilities.vue?vue&type=script&lang=js"
export * from "./PortletUnfixedVulnerabilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports